import { OperationType } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const counterpartyGroupCreateAtom = createMutationAtomFactory(
  'brokerage.counterpartyGroupCreate',
  (params: { name: string; operationType: OperationType }) => ({
    pricingCounterpartyGroupCreate: {
      __args: {
        input: {
          name: params.name,
          operationType: params.operationType,
        },
      },
      id: true,
      name: true,
      operationType: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const counterpartyGroupUpdateAtom = createMutationAtomFactory(
  'brokerage.counterpartyGroupUpdate',
  (params: { id: string; name?: string; operationType?: OperationType }) => ({
    pricingCounterpartyGroupUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          operationType: params.operationType,
        },
      },
      id: true,
      name: true,
      operationType: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const counterpartyGroupDeleteAtom = createMutationAtomFactory(
  'brokerage.counterpartyGroupDelete',
  (params: { id: string }) => ({
    pricingCounterpartyGroupDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);

export const counterpartyGroupBulkDeleteAtom = createMutationAtomFactory(
  'brokerage.counterpartyGroupBulkDelete',
  (params: { ids: string[] }) => ({
    pricingCounterpartyGroupBulkDelete: {
      __args: {
        ids: params.ids,
      },
    },
  }),
);

export const counterpartyGroupAddAccountsAtom = createMutationAtomFactory(
  'brokerage.counterpartyGroupAddAccounts',
  (params: { groupId: string; accountIds: string[] }) => ({
    pricingCounterpartyGroupAddAccounts: {
      __args: {
        groupId: params.groupId,
        accountIds: params.accountIds,
      },
    },
  }),
);

export const counterpartyGroupRemoveAccountsAtom = createMutationAtomFactory(
  'brokerage.counterpartyGroupRemoveAccounts',
  (params: { groupId: string; accountIds: string[] }) => ({
    pricingCounterpartyGroupRemoveAccounts: {
      __args: {
        groupId: params.groupId,
        accountIds: params.accountIds,
      },
    },
  }),
);
